var _rect, _rect2, _path, _rect3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBladeServers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39.25,
    y: 34,
    width: 1.5,
    height: 30
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.25,
    y: 34,
    width: 1.5,
    height: 30
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,70.75H64a.7502.7502,0,0,0,.75-.75V10A.7502.7502,0,0,0,64,9.25H16a.7502.7502,0,0,0-.75.75V70A.7502.7502,0,0,0,16,70.75Zm32.75-60h14.5v58.5H48.75Zm-16,0h14.5v58.5H32.75Zm-16,0h14.5v58.5H16.75Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 55.25,
    y: 34,
    width: 1.5,
    height: 30
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 16,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 22,
    r: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 28,
    r: 1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 16,
    r: 1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 22,
    r: 1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 28,
    r: 1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 16,
    r: 1
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 22,
    r: 1
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 28,
    r: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBladeServers);
export default __webpack_public_path__ + "static/media/icon_blade_servers.484017d449dd55ff72986b0502312188.svg";
export { ForwardRef as ReactComponent };